import './image_background.css';

export default function ImageBackground({ className, style, img, children }) {
  return (
    <div style={{ backgroundImage: `url(${img || ''})`, ...style }} className={(className || '') + ' image-background'}>
      {children}
    </div>
  );
}
